import 'babel-polyfill';
import ResizeObserver from 'resize-observer-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { configure } from 'mobx';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@/utils/scrollPolyfill';
import './index.less';
import '@/assets/css/reset.less';
import * as Sentry from '@sentry/react';
import { querySearchParam } from '@/utils/basic';
import { cookie } from '@gaodun.com/gtools';

// MobX 6 配置：禁用 strict-mode，兼容 SDK 中的 async action
configure({
    enforceActions: 'never',
});
// 扩展Window接口以包含stopSentryReporting方法
declare global {
    interface Window {
        stopSentryReporting?: () => void;
    }
}
const accessToken = querySearchParam('accessToken');
if (accessToken) {
    cookie.setCookie('Accesstoken', accessToken);
    cookie.setCookie('Refreshtoken', accessToken);
}
// @ts-ignore
if (!window?.ResizeObserver) window.ResizeObserver = ResizeObserver;
// 正式环境
// if(environment.getEnv() === ''){
Sentry.init({
    dsn: 'https://8dfd41b3e2bdb9d96a6512b4e5307d36@sentry.gaodun.com/4', // 上报地址
    environment: process.env.CROSS_ENV, // 上报环境变量   test|pre|production
    integrations: [
        Sentry.browserTracingIntegration(), // 浏览器性能追踪
        Sentry.replayIntegration(), // 捕获用户行为，并以类似视频播放的方式再现
    ],
    tracesSampleRate: 1.0, // 触发异常后发送给 Sentry 的概率
    maxBreadcrumbs: 50, // 控制应捕获的面包屑(行为栈)的总量
    profilesSampleRate: 0.01, // 性能分析的采样率
    // Session Replay
    replaysSessionSampleRate: 0, // 重播的采样率
    replaysOnErrorSampleRate: 0.01,
    ignoreErrors: [
        /^Script error\.?$/,
        /^Request failed with status code 403\.?$/,
        /^Network Error\.?$/,
        /^ResizeObserver loop limit exceeded\.?$/,
        /^ResizeObserver loop completed with undelivered notifications\.?$/,
        /^ReferenceError: h is not defined\.?$/,
        /^GaodunJSBridge is not defined\.?$/,
        /^ReferenceError: Can't find variable: h\.?$/,
        /^This group does not exist\.?$/,
        /im-not-ready\.?/i,
    ],
});

// 添加全局Sentry关闭函数
window.stopSentryReporting = () => {
    try {
        // 关闭Sentry客户端
        Sentry.close();
        console.log('Sentry上报已停止');
    } catch (error) {
        console.error('停止Sentry上报时发生错误:', error);
    }
};

// }
const root = createRoot(document.getElementById('root')!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
